import { DateTime } from 'luxon';

export const delimited = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };

  const formatter = new Intl.NumberFormat('en-US', {});

  return formatter.format(value);
}

export const dateShort = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };
  if (!value) { return ''; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATE_SHORT);
};

export const datetimeShort = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };
  if (!value) { return ''; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATETIME_SHORT);
};

export const datetimeMedium = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };
  if (!value) { return ''; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATETIME_MED);
};
